import { Avatar, Box, Stack } from '@mui/material';

import PropTypes from 'prop-types';

const AvatarText = ({ icon, value, sxTypography, sx }) => {
  return (
    <Stack direction={'row'} spacing={2} alignItems={'center'}>
      {icon && <Avatar sx={{ width: 25, height: 25, ...sx }}>{icon}</Avatar>}
      <Box
        sx={{
          fontSize: 15,
          fontWeight: 500,
          mr: 1,
          mt: 1.75,
          mb: 0.75,
          zIndex: 10,
          ...sxTypography,
        }}
      >
        {value}
      </Box>
    </Stack>
  );
};

AvatarText.propTypes = {
  icon: PropTypes.node,
  sx: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default AvatarText;
